<template>
  <div>
    <div class="application15">
      <div class="bannerTemp">
        <bannerTemp :data="bannerData"></bannerTemp>
      </div>
      <module1 :data="a"></module1>
      <module1 :data="b"></module1>
      <module1 :data="c" style="margin-bottom:150px;">
        <div slot="content">
          <img src="../../assets/images/application/application15-1.jpg" alt />
          <img src="../../assets/images/application/application15-2.jpg" alt />
          <img src="../../assets/images/application/application15-3.jpg" alt />
          <img src="../../assets/images/application/application15-4.jpg" alt />
        </div>
      </module1>
    </div>
    <div class="mobile-application15">
      <div class="mobile-bannerTemp">
        <bannerTemp :data="bannerData" :isLong="true"></bannerTemp>
      </div>
      <div class="content">
        <div class="range">
          <div class="part-title">
            业务应用范围
          </div>
          <div class="part-content">
            <p>{{ a.p }}</p>
          </div>
        </div>
        <div class="range">
          <div class="part-title">
            业务应用概述
          </div>
          <div class="part-content">
            <p>{{ b.p }}</p>
          </div>
        </div>
        <div class="range">
          <div class="part-title">
            业务应用案例
          </div>
          <el-carousel class="carousel" indicator-position="outside" height="18rem" >
            <el-carousel-item v-for=" index in 4" :key="index">
              <img :src="getImg(`application15-${index}.jpg`)" alt="Carousel Image" style="width: 100%; object-fit: contain;">
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
export default {
  name: "Application15",
  metaInfo: {
    title:
      "智慧监狱可视化管理_行业三维可视化应用解决方案-上海臻图信息技术有限公司",
    meta: [
      {
        name: "keywords",
        content: "智慧监狱,三维监狱,智慧看守所,监狱三维建模,监狱三维渲染"
      },
      {
        name: "description",
        content:
          "三维监狱管理系统需对于监狱内外建立三维立体图,并可在指挥中心的大屏上实时显示监狱管理局或下属各监狱的实时布防图和实时监控图像,在三维电子地图上显示有布防区域、摄像机位置、重点犯人位置、值班干警位置,并支持视频监控、报警、门禁、巡更、对讲等设备的显示。"
      }
    ]
  },
  data() {
    return {
      bannerData: {
        title: "智慧监狱可视化管理",
        p:
          "三维监狱管理系统需对于监狱内外建立三维立体图，并可在指挥中心的大屏上实时显示监狱管理局或下属各监狱的实时布防图和实时监控图像，在三维电子地图上显示有布防区……"
      },
      a: {
        num: "01",
        name: "业务应用范围",
        p: "监狱、看守所智慧管理信息化应用。"
      },
      b: {
        num: "02",
        name: "业务应用概述",
        p:
          "三维监狱管理系统需对于监狱内外建立三维立体图，并可在指挥中心的大屏上实时显示监狱管理局或下属各监狱的实时布防图和实时监控图像，在三维电子地图上显示有布防区域、摄像机位置、重点犯人位置、值班干警位置，并支持视频监控、报警、门禁、巡更、对讲等设备的显示。"
      },
      c: {
        num: "03",
        name: "业务应用案例"
      }
    };
  },
  methods: {
    getImg(fileName) {
      return require(`@/assets/images/application/${fileName}`);
    }
  },
  mounted: function() {}
};
</script>

<style lang="less" scoped>
//scoped
.bannerTemp {
  background-image: url("../../assets/images/other/header_bg.jpg");
}
.application15 {
  font-size: 0;
  img {
    width: 584px;
    margin-top: 20px;
    &:nth-child(2n + 1) {
      margin-right: 20px;
    }
  }
}
.mobile-application15 {
  display: none;
  width: 100%;
  flex-direction: column;
  font-family: 'Normal';
  .mobile-bannerTemp {
    width: 100%;
    background-image: url("../../assets/images/other/header_bg.jpg");
    background-position: 30%;
    background-size: cover;
    height: 28rem;
  }
  .content {
    width: 100%;
    font-family: 'Normal';
    .range {
      width: 100%;
      box-sizing: border-box;
      padding: 2rem;
      color: #333333;
      .part-title {
        width: 100%;
        text-align: center;
        font-size: 1.8rem;
        font-weight: bold;
        line-height: 3rem;
      }
      .part-content {
        font-size: 1rem;
        font-weight: 350;
        line-height: 2rem;
        margin-top: 2rem;
        text-indent: 2em;
      }
      .carousel {
        margin-top: 2rem;
      }
    }
  }
}
/deep/.el-carousel__indicators--horizontal  {
  width:100% !important;
  text-align: center !important;
  .is-active {
    .el-carousel__button {
      width: 3rem;
      height: 0.4rem;
      background: #3C80E8;
    }
  }
}
/deep/ .el-carousel__button {
  width: 0.5rem;
  height: 0.4rem;
  background: #C1E1FF;
}
/deep/ .case-carousel {
  .is-active {
    .el-carousel__button {
      width: 3rem;
      height: 0.4rem;
      background: #3C80E8;
    }
  }
}
@media (max-width: 1024px) {
  .application15 {
    display: none !important;
  }
  .bannerTemp {
    display: none !important;
  }
  .mobile-application15 { 
    display: flex !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/application/application15.vue